<template>
    <CardShell>
        <div class="pv3 bg-near-white"> 
                <h5 class="ph3">Search Filters</h5>
        </div>
        <FiltersCore class="ph3" :applyImmediately="true" />
        
    </CardShell>
    
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import FiltersCore from '@/components/search/FiltersCore.vue';

export default {
    components: {
        CardShell,
        FiltersCore
    }
};
</script>
